(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-table"] && !Shopify.designMode) return;
  try {
    (() => {
    const setQty = (row) => {
      const qty = parseInt(row.dataset.qty, 10);
      if (!qty) return;
      const scope = row.closest('.shopify-section') || document;
      const input = scope.querySelector('.quantity-input');
      if (!input) return;
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    // Actieve staffelrij markeren: hoogste tier waar het huidige aantal in
    // valt; onder de laagste staffel geen markering (zoals de oude site).
    const syncTiers = () => {
      document.querySelectorAll('.product-table__table--tiers').forEach((table) => {
        const scope = table.closest('.shopify-section') || document;
        const input = scope.querySelector('.quantity-input');
        if (!input) return;
        const qty = parseInt(input.value, 10) || 0;
        let active = null;
        const rows = table.querySelectorAll('.product-table__tier');
        rows.forEach((row) => {
          const rowQty = parseInt(row.dataset.qty, 10);
          if (!rowQty || qty < rowQty) return;
          if (!active || rowQty > parseInt(active.dataset.qty, 10)) active = row;
        });
        rows.forEach((row) => {
          row.classList.toggle('product-table__tier--active', row === active);
        });
      });
    };
    document.addEventListener('click', (e) => {
      const row = e.target.closest('.product-table__tier');
      if (row) setQty(row);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const row = e.target.closest('.product-table__tier');
      if (!row) return;
      e.preventDefault();
      setQty(row);
    });
    // Highlight live laten meebewegen met het aantal: typen (input), de
    // change die een tabel-klik dispatcht, en het theme-event van de
    // +/- knoppen en blur (quantity-selector.js, zie events.js).
    document.addEventListener('input', (e) => {
      if (e.target instanceof Element && e.target.matches('.quantity-input')) syncTiers();
    });
    document.addEventListener('change', (e) => {
      if (e.target instanceof Element && e.target.matches('.quantity-input')) syncTiers();
    });
    document.addEventListener('quantity-selector:update', () => syncTiers());
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncTiers());
    } else {
      syncTiers();
    }
    // Prijzen live herrekenen bij variantwissel. Het theme-event
    // (VariantUpdateEvent, events.js) draagt de variant als detail.resource
    // (price in centen) en de vers gerenderde pagina als detail.data.html.
    // Bij "Wissen" is resource null; dan nemen we de server-gerenderde
    // prijzen (vanaf-prijs, zie hierboven) uit die HTML over.
    const formatTierPrices = (table, priceInCents) => {
      const fmt = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: table.dataset.currency || 'EUR',
      });
      table.querySelectorAll('[data-pct]').forEach((cell) => {
        const pct = parseFloat(cell.dataset.pct);
        if (Number.isNaN(pct)) return;
        // Zelfde afronding als de Liquid-render: naar beneden op hele centen.
        cell.textContent = fmt.format(Math.floor(((100 - pct) * priceInCents) / 100) / 100);
      });
    };
    const copyTierPrices = (table, html) => {
      const fresh = html.querySelector(
        `.product-table__table--tiers[data-block-id="${table.dataset.blockId}"]`
      );
      if (!fresh) return false;
      const freshCells = fresh.querySelectorAll('[data-pct]');
      table.querySelectorAll('[data-pct]').forEach((cell, i) => {
        if (freshCells[i]) cell.textContent = freshCells[i].textContent;
      });
      return true;
    };
    document.addEventListener('variant:update', (e) => {
      const detail = e.detail || {};
      const variant = detail.resource;
      const data = detail.data || {};
      const scope =
        (e.target instanceof Element && e.target.closest('.shopify-section, dialog')) || document;
      scope.querySelectorAll('.product-table__table--tiers').forEach((table) => {
        if (data.productId && table.dataset.productId && String(data.productId) !== table.dataset.productId) {
          return;
        }
        if (data.html && copyTierPrices(table, data.html)) return;
        if (variant && variant.price) formatTierPrices(table, variant.price);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
